export function getCourierConfig() {
  const baseUrl = process.env.REACT_APP_COURIER_API_BASE_URL;
  const apiUrlSlug = process.env.REACT_APP_COURIER_API_SLUG;
  const apiKey = process.env.REACT_APP_COURIER_API_KEY;

  if (!baseUrl || !apiUrlSlug || !apiKey) {
    throw new Error(
      'Courier API is not configured. Set REACT_APP_COURIER_API_BASE_URL, REACT_APP_COURIER_API_SLUG, and REACT_APP_COURIER_API_KEY in .env'
    );
  }

  return { baseUrl, apiUrlSlug, apiKey };
}

export async function listPackagesPage({ page = 1, limit = 25, search = '' }) {
  const { baseUrl, apiUrlSlug, apiKey } = getCourierConfig();
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    search: search || '',
  });
  const url = `${baseUrl}/api/v1/shipments/${apiUrlSlug}/package?${params.toString()}`;

  let response;
  try {
    response = await fetch(url, {
      method: 'GET',
      headers: {
        'x-api': apiKey,
      },
    });
  } catch (err) {
    throw new Error(
      err && err.message
        ? `Unable to reach warehouse API: ${err.message}`
        : 'Unable to reach warehouse API. This may be a network or CORS issue.'
    );
  }

  if (!response.ok) {
    let detail = '';
    try {
      const body = await response.json();
      detail = body.message || body.error || JSON.stringify(body);
    } catch {
      detail = await response.text();
    }
    if (response.status === 401 || response.status === 403) {
      throw new Error(`API authentication failed (${response.status}). ${detail}`);
    }
    throw new Error(`Failed to fetch packages (${response.status}). ${detail}`);
  }

  const data = await response.json();
  return {
    meta: data.meta || { totalItems: 0, totalPages: 1, currentPage: page, itemsPerPage: limit },
    packages: Array.isArray(data.packages) ? data.packages : [],
  };
}

export async function listAllPackages({ search = '', limit = 25 } = {}) {
  const first = await listPackagesPage({ page: 1, limit, search });
  const totalPages = first.meta.totalPages || 1;

  const extraPageNumbers = Array.from({ length: Math.max(0, totalPages - 1) }, (_, i) => i + 2);
  const extraPages = await Promise.all(extraPageNumbers.map((page) => listPackagesPage({ page, limit, search })));
  const allPackages = [...first.packages, ...extraPages.flatMap((result) => result.packages)];

  return {
    packages: allPackages,
    meta: {
      ...first.meta,
      totalItems: allPackages.length,
      totalPages,
    },
  };
}
